module.exports = __webpack_public_path__ + "img/b04.58e9ffa3.png";